import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/stats/sentences",
      },
      queries: [],
    }),
    [],
  );
}

export const useLearningStatsSentencesPageNavigator = createPageNavigator<void>({
  useNavigator,
});
